export const PageHeader = ({ eyebrow, title, subtitle, actions, testid }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8" data-testid={testid}>
    <div>
      {eyebrow && (
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-400 mb-2">{eyebrow}</div>
      )}
      <h1 className="font-heading text-3xl sm:text-4xl font-light tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="text-slate-500 mt-1.5 text-[15px]">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);
